<div class="settings-search">
    <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input
            type="text"
            pInputText
            placeholder="Buscar opción de configuración..."
            [(ngModel)]="searchTerm"
        />
    </span>
</div>

<div class="settings-groups" *ngIf="filteredGroups.length > 0; else noResults">
    <section class="settings-group" *ngFor="let group of filteredGroups">
        <h2 class="settings-group-title">{{ group.label }}</h2>
        <div class="settings-grid">
            <a
                class="settings-card"
                *ngFor="let item of group.items"
                [routerLink]="item.routerLink"
            >
                <div class="settings-card-icon-wrapper">
                    <i [class]="item.icon"></i>
                </div>
                <div class="settings-card-content">
                    <h3>{{ item.label }}</h3>
                    <p *ngIf="item.description">{{ item.description }}</p>
                </div>
                <div class="settings-card-arrow">
                    <i class="pi pi-arrow-right"></i>
                </div>
            </a>
        </div>
    </section>
</div>

<ng-template #noResults>
    <div class="settings-no-results">
        <i class="pi pi-search"></i>
        <p>Sin resultados</p>
    </div>
</ng-template>
